import { Badge } from '@mantine/core';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

interface Props {
    chainName: string;
    patientName: string;
    appointmentCount: number;
    startDateLabel: string;
    conflictCount: number;
}

export const ChainBookingSummary = ({
    chainName,
    patientName,
    appointmentCount,
    startDateLabel,
    conflictCount,
}: Props) => (
    <div className="grid grid-cols-5 gap-4 rounded-lg border border-slate-200 bg-slate-50 p-4">
        <div className="flex min-w-0 flex-col">
            <span className="text-sm text-slate-500">Terminkette</span>
            <span className="truncate font-medium" title={chainName}>
                {chainName}
            </span>
        </div>
        <div className="flex min-w-0 flex-col">
            <span className="text-sm text-slate-500">Patient</span>
            <span className="truncate font-medium" title={patientName}>
                {patientName}
            </span>
        </div>
        <div className="flex flex-col">
            <span className="text-sm text-slate-500">Anzahl</span>
            <span className="font-medium">{appointmentCount} Termine</span>
        </div>
        <div className="flex flex-col">
            <span className="text-sm text-slate-500">Startdatum</span>
            <span className="whitespace-nowrap font-medium">{startDateLabel}</span>
        </div>
        <div className="flex flex-col">
            <span className="text-sm text-slate-500">Konflikte</span>
            {conflictCount > 0 ? (
                <Badge color="red" size="lg" leftSection={<AlertCircle className="size-3.5" />} className="self-start">
                    {conflictCount} {conflictCount === 1 ? 'Konflikt' : 'Konflikte'}
                </Badge>
            ) : (
                <Badge
                    color="green"
                    size="lg"
                    leftSection={<CheckCircle2 className="size-3.5" />}
                    className="self-start"
                >
                    Keine
                </Badge>
            )}
        </div>
    </div>
);
